import StackableModalProvider from "./stackableModalProvider";
import showModal from "./events";
import reducer from "./reducer";
import { modalComponent } from "./decorator";

export default StackableModalProvider;
export { showModal, reducer, modalComponent };
